import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";
import { useMemo } from "react";
import { useFlags } from "../../../../server/optimizely";
import { $isDataTableCellNode } from "../nodes/data-table-cell-node";
import { $findAllNodesOfType } from "./find-all-nodes-of-type";

export function useDataTable(): boolean {
  const [editor] = useLexicalComposerContext();

  const {
    flags: { lexical_table },
  } = useFlags("lexical_table");

  const hasNodes = useMemo(() => {
    let present = false;

    editor.update(
      () => {
        present = $findAllNodesOfType($getRoot(), $isDataTableCellNode).length > 0;
      },
      { discrete: true },
    );

    return present;
  }, [editor]);

  return lexical_table || hasNodes;
}
